import React, { FC, memo, useCallback, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import StepContent from '../../../Common/StepContent';

// import useWindowSize from '../../../../hooks/useWindowSize';
// import PCHeader from './PCHeader/MyPagePCHeader.index';
// import MobileHeader from './MobileHeader/MyPageMobileHeader.index';

const Header: FC = () => {
  const history = useHistory();
  // const getIsMobile = () => window.innerWidth < 576;
  // const isMobile = useWindowSize(getIsMobile);
  const url = useLocation().pathname;

  // 根据当前URL确定应该显示的步骤
  const currentStep = useMemo(() => {
    // 根据路径确定步骤
    if (url === '/') {
      return 1; // 店舗選択
    }
    if (url === '/reservation/schedule') {
      return 2; // プログラム・日時選択
    }
    if (url === '/register' || url === '/register/confirm') {
      return 3; // アカウント登録
    }
    if (url === '/register/complete') {
      return 4; // 予約完了
    }

    // 默认返回第一步
    return 0;
  }, [url]);

  const toSimpleAuth = useCallback(() => {
    sessionStorage.removeItem('simpleAuthResult_visitorId');
    sessionStorage.removeItem('simpleAuthResult_birthday');
    sessionStorage.removeItem('simpleAuthResult_telephone');
    history.push('/simpleAuth');
  }, [history]);

  return (
    <>
      <header className="logo-layout">
        <Link to="/">
          <img src="/images/logo.svg" alt="Header logo" className="linked-icon" />
        </Link>
        <p className="logo-description">
          24時間年中無休のスポーツジム
          <br />
          ミラフィットネス
        </p>
        <nav className="p-visitor-header">
          <button type="button" className="p-visitor-header__button" onClick={toSimpleAuth}>
            予約確認
          </button>
        </nav>
      </header>
      <header className="title-layout">
        <h2 className="title">体験・見学</h2>
      </header>
      {currentStep > 0 && <StepContent currentStep={currentStep} />}
    </>
  );
};

export default memo(Header);
